import AuditUpdateComponent, {
  AuditUpdateComponentProps,
} from './AuditUpdateComponent';

export default AuditUpdateComponent;

export type { AuditUpdateComponentProps };
